import type { ReactNode } from 'react'
import { errorText } from '@mezha/api'
import { fromFailure, type ApiFailure } from '../api/baseApi'
import { Emblem } from './brand/Emblems'

export function Loading({ text = 'Загружаем…' }: { text?: string }) {
  return <div className="state" role="status" aria-live="polite">{text}</div>
}

export function Empty({ children }: { children: ReactNode }) {
  return <div className="state">{children}</div>
}

/** A read failed: the message goes where the data would be, with «Повторить». */
export function Failure({ error, retry, what = 'Данные' }: { error: unknown; retry?: () => void; what?: string }) {
  const text = error && typeof error === 'object' && 'code' in error ? errorText(fromFailure(error as ApiFailure)) : 'Связь потеряна. Попробуйте ещё раз'
  return (
    <div className="state state--error" role="alert">
      <span><Emblem name="system.error" size={18} /> {what} не загрузились: {text}</span>
      {retry && <button type="button" className="linkbtn" onClick={retry}>Повторить</button>}
    </div>
  )
}
